import { mutate } from 'swr'

export const clearAPICache = () => {
  mutate(() => true, undefined, { revalidate: false })
}
